import copy from "clipboard-copy";

export const CustomInput = ({
  placeholder = "",
  value = null,
  onChange = () => {},
  name = "",
}) => {
  return (
    <div className="custom-input-container">
      <img className="only-show-mobile" src="/img/new-icons/link.svg" />
      <input
        type="text"
        name={name}
        className="text-input"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        sz="large"
      />
      <button
        className={`custom-copy${!value.length ? " mobile-hidden" : ""}`}
        data-button-type="secondary"
        data-icon
        data-icon-only
        onClick={() => {
          copy(value);
        }}
      >
        <img alt="copy" src="/img/new-icons/copy.svg" className={`w-5 h-5`} />
      </button>
    </div>
  );
};
